module.exports = __webpack_public_path__ + "assets/StoredValueDetails.00a798a6.svg";